<div class="container-fluid">
    <div class="jumbotron jumbotron-fluid">
        <app-gms-logout class="jumbp-post"></app-gms-logout>
    </div>
    <div class="container">
        <div class="row text-center">
            <div class="col welcome_msg_container text-center">
                <!-- <h2 class="hi_msg">Hi {{ '&lt;baba &gt; sd &gt; &gt;  &amp; &lt; &lt; &lt; asdf' | convertsymbol}}</h2> -->
                <h2 class="hi_msg">Hi {{userName}}</h2>
                <!-- <button (click)="test()">test</button> -->
                <h4 class="welcome_msg">Welcome to Game Management System!! </h4>
            </div>
        </div>
    </div>

    <div class="nav-menus-section">
        <div class="menu-item p-2 bd-highlight" *ngFor="let menuItem of getMenusData()">
            <div class="card {{menuItem}}" (click)="navigateToGameManagement(menuItem)">
                <div class="card-body">
                    <i class="fa fa-gamepad fa-5x" style="color:#FF6347" aria-hidden="true"></i>
                </div>

            </div>
            <p class="card-text text-center">{{navlinksData[menuItem].name}}</p>
        </div>
        <!-- <div class="col-lg-3 col-sm-6 col-xs-12 text-center">
            <div class="card game-management" (click)="navigateToGameManagement()">
                <div class="card-body">
                    <i class="fa fa-gamepad fa-5x" style="color:#FF6347" aria-hidden="true"></i>
                </div>
            </div>
            <p class="card-text">Games Management</p>
        </div>
        <div class="col-lg-3 col-sm-6 col-xs-12 text-center">
            <div class="card chat-management" (click)="navigateToChatManagement()">
                <div class="card-body">
                    <i class="fa fa-weixin fa-5x" style="color:#FF6347" aria-hidden="true"></i>
                </div>
            </div>
            <p class="card-text">Chat Management</p>
        </div>
        <div class="col-lg-3 col-sm-6 col-xs-12 text-center">
            <div class="card data-reports" (click)="navigateToDataReports()">
                <div class="card-body">
                    <i class="fa fa-database fa-5x" style="color:#FF6347" aria-hidden="true"></i>
                </div>
            </div>
            <p class="card-text text-center">Data and Reports</p>
        </div>
        <div class="col-lg-3 col-sm-6 col-xs-12 text-center">

            <div class="card customer-services" (click)="navigateToCustomerService()">
                <div class="card-body">
                    <i class="fa fa-user-o fa-5x" style="color:#FF6347" aria-hidden="true"></i>
                </div>
            </div>
            <p class="card-text">Customer Services</p>
        </div> -->
    </div>
</div>